module.exports = __webpack_public_path__ + "img/calendar-9_fill.cf2cc5f6.svg";